<template>
    <intranet-nav-content>
        <template slot="links">
            <intranet-nav-content-link-exact :link="{ name: 'postulantes', path: { name: 'admin-postulants-list' } }"/>
            <intranet-nav-content-link :link="{ name: 'test', path: { name: 'admin-postulants-list-test' } }"/>
        </template>
    </intranet-nav-content>
</template>

<script>
import IntranetNavContent from '@/layout/NavContent/IntranetNavContent';
import IntranetNavContentLink from '@/layout/NavContent/IntranetNavContentLink';
import IntranetNavContentLinkExact from '@/layout/NavContent/IntranetNavContentLinkExact';

export default {
    name: 'AdminPostulants',
    components: { 
        IntranetNavContent,
        IntranetNavContentLink,
        IntranetNavContentLinkExact
    },
};
</script>
